import { render, staticRenderFns } from "./CollectionsSegments.vue?vue&type=template&id=5ee66eca"
import script from "./CollectionsSegments.vue?vue&type=script&lang=js"
export * from "./CollectionsSegments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports